import React from "react"
import { graphql, useStaticQuery } from "gatsby"
//import { useLocalization } from "gatsby-theme-i18n"
import { useI18next } from "gatsby-plugin-react-i18next"
import { useTranslation } from "react-i18next"
import Fuse from "fuse.js"

const useSearch = () => {
  const { t } = useTranslation()
  //const { locale } = useLocalization()
  const { language: locale } = useI18next()

  const data = useStaticQuery(graphql`
    query SearchDocumentsQuery {
      documents: allCollectionSearchable {
        nodes {
          title
          excerpt
          url
          locale
          collection
        }
      }
    }
  `)

  /**
   * Get collections that are being used
   */
  const collections = data.documents.nodes
    .map(n => n.collection)
    .filter((value, index, self) => self.indexOf(value) === index)

  /**
   * Get all documents in the current locale
   */
  const documents = React.useMemo(
    () => data.documents.nodes.filter(n => n.locale === locale),
    [data, locale]
  )

  /**
   * Get the search history stored in the localStorage
   */
  const history = React.useMemo(() => {
    if (typeof window === "undefined") {
      return []
    }

    let history = localStorage.getItem("search-history") || "[]"
    history = JSON.parse(history)
    if (history.length > 0) {
      const documentsInHistory = documents
        .filter(d => history.includes(d.url))
        .map(d => ({
          ...d,
          type: t(`collections.${d.collection}.plural`),
          to: d.url,
        }))

      return history
        .map(slug => documentsInHistory.find(d => d.url === slug))
        .filter(x => !!x)
    }
  }, [t, documents])

  /**
   * Get the Fuse object
   */
  const search = React.useMemo(() => {
    if (!data.documents) {
      return null
    }

    return new Fuse(documents, {
      keys: [
        {
          name: "title",
          weight: 1,
        },
        {
          name: "excerpt",
          weight: 2,
        },
      ],
      minMatchCharLength: 3,
      threshold: 0.2,
    })
  }, [data, documents])

  return {
    isLoading: search === null,
    fuse: search,
    documents,
    history,
    collections,
  }
}

export default useSearch
